import React from 'react';
import './Hamburger.scss';
import IntroCopy from '../Intro/IntroCopy';
import NavRight from '../NavRight/NavRight';
import { useSwipeable } from 'react-swipeable';
import howToIcon from '../../assets/how-to-use.svg';

function Hamburger({
  showHamburger,
  setShowHamburger,
  savedDataArray,
  handleClickHamburger,
  hamburgerRef,
  setShowCompare,
  setShowAreaDetail,
  introText,
  handleClickI,
  setCurrentState,
  handleClickNavButtons,
  buttonActive
}) {
  const handlers = useSwipeable({
    onSwipedLeft: () => (showHamburger ? handleClickHamburger('close') : null)
  });

  return (
    <div className="hamburger mobile-only" ref={hamburgerRef}>
      <div className="hamburger__container" {...handlers}>
        <IntroCopy showHamburger={showHamburger} introText={introText} />
        <div className="hamburger__resetCompare">
          <NavRight
            setShowCompare={setShowCompare}
            setShowAreaDetail={setShowAreaDetail}
            setShowHamburger={setShowHamburger}
            showHamburger={showHamburger}
            handleClickHamburger={handleClickHamburger}
            savedDataArray={savedDataArray}
            setCurrentState={setCurrentState}
            handleClickNavButtons={handleClickNavButtons}
            buttonActive={buttonActive}
          />

          <div className="hamburger__resetCompare__name">
            <p className="hamburger__resetCompare__text">Back</p>
            <p className="hamburger__resetCompare__text">Compare</p>
          </div>
        </div>
        <div className="hamburger__resetCompare__howto">
          <img
            src={howToIcon}
            className="icon icon--howto"
            alt="icon"
            onClick={() => {
              handleClickI();
              handleClickHamburger('close');
            }}
          />
          <p className="hamburger__resetCompare__text hamburger__resetCompare__howto__text">
            How to use the map
          </p>
        </div>
      </div>
    </div>
  );
}

export default Hamburger;
